import React, { FC } from 'react'
import CustomLabel from '../CustomLabel'
import CustomInput from '../CustomInput'
import { maxLengthRule, requiredRule } from '../../utils/formRules'
import { TControls } from '../../../features/userInfoForm/types'

const PrevBuildingName: FC<TControls> = ({ control }) => (
  <div>
    <CustomLabel label="Previous Building Name"/>
    <CustomInput
      name="prevBuildingName"
      control={control}
      rules={{
        maxLength: maxLengthRule(50)
      }}
    />
  </div>
)
export default PrevBuildingName
